export class ImosUpdateList extends HTMLElement {
  connectedCallback(): void {
    const limit = Number(this.getAttribute('limit') ?? '5');
    const rows = Array.from(
      this.querySelectorAll<HTMLTableRowElement>('tbody > tr'),
    );
    const toggle = this.querySelector<HTMLElement>('[data-toggle]');

    if (rows.length <= limit || !toggle) {
      toggle?.remove();
      return;
    }

    const hidden = rows.slice(limit);
    for (const row of hidden) {
      row.hidden = true;
    }

    toggle.addEventListener('click', () => {
      for (const row of hidden) {
        row.hidden = false;
      }
      toggle.remove();
    });
  }
}

customElements.define('imos-update-list', ImosUpdateList);
